import script from "./PaymentTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentTab.vue?vue&type=script&setup=true&lang=js"

import "./PaymentTab.vue?vue&type=style&index=0&id=bd0a3eba&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd0a3eba"]])

export default __exports__